import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultAnnualFee } from '@classes/default-annual-fee';
import { DefaultDegressivitySlice } from '@classes/default-degressivity-slice';
import { DefaultPrice } from '@classes/default-price';
import { DefaultPublicDegressivitySlice } from '@classes/default-public-degressivity-slice';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DefaultPriceService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/defaultPrice';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getDefaultAnnualFee(): Observable<Array<DefaultAnnualFee>> {
    return this.http.get<Array<DefaultAnnualFee>>(`${this.basePath}/getDefaultAnnualFee`);
  }

  getDefaultDegressivitySlice(): Observable<Array<DefaultDegressivitySlice>> {
    return this.http.get<Array<DefaultDegressivitySlice>>(`${this.basePath}/getDefaultDegressivitySlice`);
  }

  getDefaultPrice(): Observable<Array<DefaultPrice>> {
    return this.http.get<Array<DefaultPrice>>(`${this.basePath}/getDefaultPrice`);
  }

  getDefaultPublicDegressivitySlice(): Observable<Array<DefaultPublicDegressivitySlice>> {
    return this.http.get<Array<DefaultPublicDegressivitySlice>>(`${this.basePath}/getDefaultPublicDegressivitySlice`);
  }
}
